import React, { FC, SyntheticEvent } from 'react'
import { t, Trans } from '@lingui/macro'

import Loader from '../../../components/common/loader/Loader'
import { Dropdown } from '../../../components/common/dropdown/Dropdown'
import IconPeople from '../../../components/common/icon/IconPeople'
import { FilterGroupModal, FilterGroupModalProps } from './FilterGroupModal'
import { ICampaignActionReportFilters } from './CampaignActionReport'

import IconFilter from 'public/assets/img/filter-icon.svg'
import { useAllGroupsQuery } from 'front-end/src/graphql/commonQueries/allGroups.codegen'
import { ButtonClean, ButtonDark } from 'front-end/src/components'

import './CampaignActionReportFilters.less'
import IconPlus2 from 'front-end/src/components/common/icon/IconPlus2'
import IconClose from 'front-end/src/components/common/icon/IconClose'
import {
  EntityFilterModalControlProvider,
  ModalFilterEntitiesControlContext,
  ModalFilterEntitiesEnum
} from '../../../components/common/entityFiltersModals'

interface IProps {
  onFilterChange: (filters: Partial<ICampaignActionReportFilters>) => void
  filters: ICampaignActionReportFilters
}

export const CampaignActionReportFilters: FC<IProps> = ({
  onFilterChange,
  filters
}) => {
  const { data, loading } = useAllGroupsQuery()

  if (loading) {
    return <Loader />
  }

  const removeGroupsFromFilter = (
    e: SyntheticEvent<EventTarget, Event>
  ): void => {
    e.stopPropagation()
    onGroupsChanged([])
  }

  const getGroupNameById = (groupId: number): string => {
    const group = data?.groups.find((item) => item.id === groupId)
    return group ? group.name : ''
  }

  const onGroupsChanged = (groupIds: number[]) => {
    onFilterChange({ groupIds })
  }

  const isGroupSelected = () => {
    return filters.groupIds && filters.groupIds.length > 0
  }

  return (
    <EntityFilterModalControlProvider>
      <ModalFilterEntitiesControlContext.Consumer>
        {({ showModal, activeModal }) => {
          const showGroupsFilterModal = () =>
            showModal(ModalFilterEntitiesEnum.GROUP)

          return (
            <div className="CampaignReportsFilters">
              <div className="CampaignReportsFilters__wrapper">
                <label className="CampaignReportsFilters__label">
                  <img
                    className="CampaignReportsFilters__label__icon"
                    src={IconFilter}
                    alt={t`Filter`}
                  />
                  <Trans>Showing</Trans>:
                </label>
                {isGroupSelected() && (
                  <ButtonDark
                    className="CampaignReportsFilters__item"
                    onClick={showGroupsFilterModal}
                    rightIcon={<IconClose onClick={removeGroupsFromFilter} />}
                  >
                    <span className="CampaignReportsFilters__item__label">
                      {filters.groupIds.length > 1
                        ? `${filters.groupIds.length} groups`
                        : getGroupNameById(filters.groupIds[0])}
                    </span>
                  </ButtonDark>
                )}
                <Dropdown
                  tabIndex={-1}
                  positionOfContent="left"
                  _focus={{
                    outline: 'none'
                  }}
                  content={
                    <div className="AddFilterMenuList Dropdown">
                      <div className="DropdownLabel">
                        <Trans>Filter types</Trans>:
                      </div>
                      <ButtonClean
                        className="DropdownLink"
                        justifyContent="start"
                        onClick={showGroupsFilterModal}
                        disabled={isGroupSelected()}
                        leftIcon={<IconPeople />}
                      >
                        <Trans>Groups</Trans>
                      </ButtonClean>
                    </div>
                  }
                >
                  <ButtonClean
                    size="sm"
                    fontSize="md"
                    m="4px"
                    className="CampaignReportsFilters__add"
                    leftIcon={<IconPlus2 />}
                  >
                    <Trans>Add filter</Trans>
                  </ButtonClean>
                </Dropdown>
              </div>
              {activeModal === ModalFilterEntitiesEnum.GROUP && (
                <FilterGroupModal
                  onChange={onGroupsChanged}
                  groups={
                    (data?.groups ?? []) as FilterGroupModalProps['groups']
                  }
                  selectedGroupIds={filters.groupIds || []}
                />
              )}
            </div>
          )
        }}
      </ModalFilterEntitiesControlContext.Consumer>
    </EntityFilterModalControlProvider>
  )
}
